<template>
  <v-card class="mx-auto " min-height="200"  elevation="2" outlined>
    <v-img @click="$router.push(`/${isPublic?'public':isHefe?'hefe':'obrero'}/job-details/${job._key}?tab=Summary`)" :src="picture||require(`@/assets/${job.category||'Other'}.svg`)" cover class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="150px">
      <v-icon color="white" style="position:absolute;top:12px;right:12px">mdi-information-outline</v-icon>
      <v-card-text v-if="!fromDashboard" class="overline">({{jobData.dist}} miles away) </v-card-text>
      <v-card-text v-else class="overline">{{$language.settings.Categories[job.category]}}</v-card-text>
      <v-card-title class="white--text ">{{job.startDate|formatShortDate}} at {{(job.startTime||{}).h}}:{{(job.startTime||{}).mm}} {{(job.startTime||{}).A}}</v-card-title>
      <v-card-subtitle class="white--text ">{{job.title}}</v-card-subtitle>
    </v-img>
    <v-list-item @click="$router.push(`/${isPublic?'public':'obrero'}/job-details/${job._key}?tab=Summary`)" v-if="!fromDashboard">

      <v-list-item-content :class="fromDashboard?'py-0':''">
        <v-list-item-title class="pb-2">

          <span v-if="!job.bid">${{ job.compensation }} {{ job.rateType === 'Hourly' ? $language.jobListItem['per hour'] : ''}}</span>
          <span v-else>Open Bid</span>
          <span> • </span>
          <span>{{$language.settings.Categories[job.category]}}</span>
          <span> • </span>
          <span>{{job.repeat?$language.addJob['Ongoing Job']:$language.addJob['One-time Job']}}</span>
          <span v-if="fromDashboard"> • </span>
          <span :class="`font-weight-bold ${getColor(job.status)}`" v-if="fromDashboard"> {{$language.jobDetails.status[job.status]}} </span>

        </v-list-item-title>
        <span class="caption" v-if="!fromDashboard">{{job.jobDesc|formatDesc}}</span>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions fill-height v-if="fromDashboard" class="pa-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title :class="`font-weight-bold ${getColor(job.status)}`">{{$language.jobDetails.status[job.status]}}</v-list-item-title>
        </v-list-item-content>
        <template v-if="isHefe">
          <v-list-item-action>
            <v-btn icon @click="()=>{ $vuetify.breakpoint.lgAndUp? $router.push(`/hefe/job-details/${job._key}?tab=Summary`):$router.push(`/hefe/job-details/${job._key}?tab=Applicants`)}">
              <v-badge color="red" :content="job.numberOfApplicants" v-if="job.numberOfApplicants>0" dot>
                <span>
                  <v-icon>people</v-icon>
                </span>
              </v-badge>
              <span v-else>
                <v-icon>people</v-icon>
              </span>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="mx-4">

            <v-btn icon  @click="openChat" :disabled="!hasApplicants">
              <!-- @click="$router.push(`/hefe/job-details/${job._key}?tab=Messages`)" -->
              <v-badge color="red" :content="job.showMessageWarning" v-if="job.showMessageWarning" dot>
                <span>
                  <v-icon>chat</v-icon>
                </span>
              </v-badge>
              <span v-else>
                <v-icon>chat</v-icon>
              </span>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="ml-0">

            <v-btn icon @click="()=>{ $vuetify.breakpoint.lgAndUp? $router.push(`/hefe/job-details/${job._key}?tab=Summary`):$router.push(`/hefe/job-details/${job._key}?tab=Applicants`)}">
              <v-badge color="red" :content="job.status" v-if="job.status==='Pending Payment'||pendingPayments" dot>
                <span>
                  <v-icon>payment</v-icon>
                </span>
              </v-badge>
              <span v-else>
                <v-icon>payment</v-icon>
              </span>
            </v-btn>
          </v-list-item-action>
        </template>
        <template v-else>

          <v-list-item-action>
            <v-btn icon @click="navigate" :disabled="job.status==='Declined'||job.status==='Applied'||job.status==='Invited'||job.status==='Completed'||job.status==='Paid'">
              <span>
                <v-icon>directions</v-icon>
              </span>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon class="mx-4" @click="openChat" :disabled="job.status==='Declined'||job.status==='New'">
            <!-- @click="$router.push(`/obrero/job-details/${job._key}?tab=Messages`)" -->
              <v-badge color="red" :content="job.showMessageWarning" v-if="job.showMessageWarning" dot>
                <span>
                  <v-icon>chat</v-icon>
                </span>
              </v-badge>
              <span v-else>
                <v-icon>chat</v-icon>
              </span>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="ml-0">
            <v-btn icon @click="openTime" :disabled="job.status==='Declined'||job.status==='Applied'||job.status==='Invited'||job.status==='Completed'||job.status==='Paid'">
              <v-icon >mdi-play-circle-outline</v-icon>
            </v-btn>
          </v-list-item-action>
        </template>

      </v-list-item>
    </v-card-actions>
    <v-dialog v-model="ratingDialog" modal max-width="400px" transition="slide-y-reverse-transition">
      <v-card color="grey darken-3">
        <v-card-title primary-title>
          <span class="title">{{ $language.jobDetails['Review for'] }} Hefe</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-center>
            <v-rating size="24" large v-model="rating.rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull"></v-rating>
            <v-textarea outlined label="Review" v-model="rating.comment" class="mt-2"></v-textarea>
          </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="ratingDialog = false">Cancel</v-btn>
          <v-btn color="primary" depressed @click.native="rate">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['jobData', 'color', 'isInvite', 'isPublic', 'fromDashboard', 'fromSearch'],
  data () {
    return {
      sub: '',
      picture: null,
      job: {
        category: 'Agriculture'

      },
      rating: {
        rating: 0,
        comment: '',
        ratedByName: '',
        ratedById: ''
      },
      ratingDialog: false
    }
  },

  mounted () {
    if (this.isInvite) {
      fb.database.ref(`jobs/${this.jobData._key}/public`).once('value').then((snapshot) => {
        this.job = snapshot.val()
        this.job.status = 'Invited'
        this.picture = ((this.job.pictures || {})[0] || {}).url
      })
    } else {
      this.job = this.jobData
      this.rating = (this.jobData.rating || {})
      fb.database.ref(`jobs/${this.jobData._key}/public/pictures/0`).once('value').then((snapshot) => {
        var pic = snapshot.val()
        this.picture = (pic || {}).url
      })
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    hasApplicants () {
      return ((this.job || {}).hiredWorkers || 0) > 0 || ((this.job || {}).numberOfApplicants || 0) > 0
    },
    isHefe () {
      if (this.job.createdBy === this.currentUser.uid) {
        return true
      }
      return false
    },
    formattedName () {
      var str = ((this.job || {}).hefeName || 'N N').split(' ')
      var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      return name
    },
    pendingPayments () {
      var pending = Object.keys((this.job || {}).pendingPayment || {}).reduce((acc, key) => {
        if (((this.job || {}).pendingPayment || {})[key] === true) {
          acc += 1
        }
        return acc
      }, 0)
      return pending
    }

  },
  methods: {
    async getPhoto () {

    },
    navigate () {
      fb.database.ref(`jobs/${this.job._key}/public/address`).once('value').then((snapshot) => {
        var address = snapshot.val()
        window.location = address.url
      })
    },
    openDialog () {
      this.$emit('job', this.job)
    },
    async rate () {
      this.buttonLoading = true
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/rating`] = this.rating
      updates[`/user/${this.job.hefeId}/profile/public/ratings/${this.job._key}`] = this.rating
      fb.database.ref().update(updates)
      this.buttonLoading = false
      this.ratingDialog = false
    },
    getColor (status) {
      switch (status) {
        case 'Applied':
          return 'amber--text'
        case 'Started' :
          return 'green--text'
        case 'Hired':
          return 'green--text'
        case 'Scheduled':
          return 'blue--text'
        case 'Published-Public':
          return 'primary--text'
        case 'Published-Private':
          return 'primary--text'
        case 'Cancelled':
          return 'grey--text'
        default:
      }
    },
    openChat () {
      this.$store.commit('setChatOpen', { open: true, date: new Date() })
      this.$nextTick(() => {
        this.$store.dispatch('changeChatSelection', { jobId: this.job._key, isHefe: this.isHefe, currentUser: this.currentUser.uid })
      })
    },
    openTime () {
      this.$store.commit('setTimeOpen', { open: true, date: new Date() })
      this.$nextTick(() => {
        this.$store.dispatch('changeTimeSelection', { jobId: this.job._key })
      })
    }
  },
  watch: {
    jobData () {
      if (!this.isInvite) {
        this.job = this.jobData
      }
    }
  },
  filters: {
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },

    formatTime (val) {
      return moment(val).format('hh:mm a')
    },
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatDesc (val) {
      if (!val) {
        return '-'
      }
      return val.length > 105 ? `${val.substring(0, 105)}...` : val
    }
  }
}
</script>
